import { ComponentPropsWithRef } from 'react';
import { getS3Url } from './get-s3-url';

export type S3VideoProps = {
  path?: string;
} & Omit<ComponentPropsWithRef<'video'>, 'src'>;
export const S3Video = function S3Video({
  ref,
  path,
  ...rest
}: S3VideoProps & {
  ref?: React.Ref<HTMLVideoElement>;
}) {
  const url = getS3Url(path);

  return <video ref={ref} src={url?.toString()} {...rest} />;
};
